import { Epic } from "redux-observable";
import { switchMap, filter } from "rxjs/operators";
import { Observable } from "rxjs";
import { IState, Dependencies } from "../@types";
import { RootAction } from "../actions";
import { isActionOf } from "typesafe-actions";
import { licensesActionsAsync } from "../actions/licensesActions";
import { clientsActionsAsync } from "../actions/clientsActions";
import { Auth } from "aws-amplify";
import { formatCounts } from "../../utils/formatData";

export const allocateCustomerLicencesEpic: Epic<
    RootAction,
    RootAction,
    IState,
    Dependencies
> = (action$, state$, dependencies) => {
    return action$.pipe(
        filter(isActionOf([
            licensesActionsAsync.allocateCustomerLicences.request,
        ])),
        switchMap(action => {
            return new Observable<RootAction>(observer => {
                const state = state$.value as IState;
                const { apiGatewayUrl } = state.constants;
                const edited = action.payload;
                const user = state.users.user;
                const licenseApiKey = state.constants.licenseApiKey;
                async function allocateCustomerLicences() {
                    const session = await Auth.currentSession();
                    const token = session.getIdToken().getJwtToken();

                    if (!user) throw "No user";

                    const counts = await dependencies.licensesApi.allocateCustomerLicences({
                        apiGatewayUrl,
                        token,
                        licenseApiKey,
                        edited,
                    });
                    const formatted = formatCounts(counts);
                    observer.next(licensesActionsAsync.allocateCustomerLicences.success({ counts: formatted }));
                    observer.next(licensesActionsAsync.getClientLicences.request({ clientId: edited.client_id }));
                }
                allocateCustomerLicences().catch(error => {
                    console.log(error);
                    observer.next(licensesActionsAsync.allocateCustomerLicences.failure({ error }));
                });
            });
        })
    );
}